import { createApi } from '@reduxjs/toolkit/query/react';

import { BFF_BASE_URL } from '@/requests';

import { createBaseQueryWithLock } from '../store.utils';

export const bffApi = createApi({
  reducerPath: 'bffApi',
  baseQuery: createBaseQueryWithLock({
    baseUrl: BFF_BASE_URL,
  }),
  endpoints: () => ({}),
});
